import styles from "./DeliveryHighlights.module.scss";
import { Props } from "../../DeliveryAndGuaranteesMessageUI";
import { ClickAndCollect } from "../ClickAndCollect/ClickAndCollect";
import { ListWithIcon } from "@/components/DeliveryAndGuaranteesMessage/components/ListWithIcon";
import { checkTimedContentIsActive } from "@/components/ProductAccordion/components/ProductDeliveryOptionsAccordion/util/checkTimedContentIsActive.ts";

export const DeliveryHighlights = ({
  message,
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
  showClickAndCollect = "never",
  showFreeReturns = false,
  showFreeReturnsWithRestrictions = false,
  hideDeliveryMessage,
  returnsEndDate,
  returnsStartDate,
  show2ManDeliveryMessage = false,
  twoManDeliveryPrice = undefined,
  isDeliveryAndGuaranteeUpdatesEnabled,
}: Props) => {
  if (hideDeliveryMessage) {
    return null;
  }

  const showClickAndCollectMessage =
    showClickAndCollect === "always" ||
    (showClickAndCollect === "available" && isClickAndCollectAvailable);

  const showTimedFrameCopy = checkTimedContentIsActive(
    returnsStartDate,
    returnsEndDate,
  );

  return (
    <ul data-testid="product:delivery-message" className={styles.message}>
      {showClickAndCollectMessage && (
        <ClickAndCollect
          isClickAndCollectAvailable={isClickAndCollectAvailable}
          isOverClickAndCollectThreshold={isOverClickAndCollectThreshold}
          isDeliveryAndGuaranteeUpdatesEnabled={
            isDeliveryAndGuaranteeUpdatesEnabled
          }
        />
      )}

      {message && (
        <ListWithIcon
          cssClasses={styles.deliveryMessage}
          textMessage={message}
          iconType="delivery"
        />
      )}
      {show2ManDeliveryMessage && twoManDeliveryPrice !== undefined && (
        <ListWithIcon
          cssClasses={styles.deliveryMessage}
          textMessage={` Standard delivery £${twoManDeliveryPrice.toFixed(2)}`}
          iconType="delivery"
        />
      )}
      {showFreeReturns && (
        <ListWithIcon
          cssClasses={styles.deliveryMessage}
          textMessage={` Free returns${showTimedFrameCopy ? " until 23 January" : ""}${showFreeReturnsWithRestrictions ? ", restrictions apply" : ""}`}
          iconType="returns"
        />
      )}
    </ul>
  );
};
